import { render } from "./PreDefinedAmounts.vue?vue&type=template&id=24b3168e&ts=true"
import script from "./PreDefinedAmounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreDefinedAmounts.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/PreDefinedAmounts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24b3168e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24b3168e', __exports__)) {
    api.reload('24b3168e', __exports__)
  }
  
  module.hot.accept("./PreDefinedAmounts.vue?vue&type=template&id=24b3168e&ts=true", () => {
    api.rerender('24b3168e', render)
  })

}


export default __exports__